import { useMemo } from "react"
import { useGetOrganisationsQuery } from "@store/services"
import { DropdownOptions } from "@custom-types/common"

type useOrgDivOptionsReturn = {
  organisationOptions: DropdownOptions
  divisionOptions: DropdownOptions
}

export const useOrgDivOptions = (organisationKey: string): useOrgDivOptionsReturn => {
  const { data: organisationsData } = useGetOrganisationsQuery({})

  const organisationsListWithDivisions = useMemo(() => {
    const orgs: { [key: string]: Set<string> } = {}

    organisationsData?.items.forEach((org) => {
      if (!orgs[org.key]) {
        orgs[org.key] = new Set()
      }

      // @ts-expect-error Types needs fixing (value is possibly undefined) - temp bypass for bulk migration
      org?.divisions?.forEach((division) => orgs[org.key].add(division.key))
    })

    return orgs
  }, [organisationsData])

  const organisationOptions = useMemo(
    () =>
      Object.keys(organisationsListWithDivisions).map((key) => ({
        id: key,
        value: key,
      })),
    [organisationsListWithDivisions],
  )
  const divisionOptions = useMemo(
    () =>
      Array.from(organisationsListWithDivisions[organisationKey] || []).map((key) => ({
        id: key,
        value: key,
      })),
    [organisationsListWithDivisions, organisationKey],
  )

  return {
    organisationOptions,
    divisionOptions,
  }
}
